import Video from 'app/components/tv/models/video';

const START_TIME = 0;
const VIDEO_DURATION = 20;

export default class SportvideoVideo extends Video {
  get startTime(): number {
    return this.startSec ?? START_TIME;
  }

  get videoDuration(): number {
    return this.duration ?? VIDEO_DURATION;
  }

  isSeekable(): boolean {
    return false;
  }

  manuallyEndAt(): number | null {
    return null;
  }

  showFuPaTvLogo(): boolean {
    return false;
  }
}
